(() => {
  const ROOT_SEL = '[data-reviews]';
  const ITEM_SEL = '.rw-container-contant';
  const GAP = 14;
  const COLS = 2;

  const microtask = window.queueMicrotask
    ? window.queueMicrotask.bind(window)
    : (cb) => Promise.resolve().then(cb);

  document.querySelectorAll(ROOT_SEL).forEach((rootEl) => {
    const container = rootEl.querySelector('.rw-container');
    if (!container) return;

    const cards = Array.from(rootEl.querySelectorAll(ITEM_SEL));
    if (!cards.length) return;

    const button = rootEl.querySelector('[data-rw-loadmore]');
    const mql = window.matchMedia('(max-width: 767px)');

    const desktopBatch = parseInt(
      rootEl.dataset.reviewLoadDesktop || rootEl.getAttribute('data-review-load-desktop') || '3',
      10
    );
    const mobileBatch = parseInt(
      rootEl.dataset.reviewLoadMobile || rootEl.getAttribute('data-review-load-mobile') || '2',
      10
    );

    const currentBatch = () => (mql.matches ? mobileBatch : desktopBatch);

    let shownCount = 0;
    let lastContainerWidth = 0;

    let queued = false;
    let queuedForce = false;

    const updateButton = () => {
      if (!button) return;

      const label =
        button.getAttribute('data-label') ||
        button.getAttribute('aria-label') ||
        button.textContent ||
        'Show more reviews';

      const emptyLabel = button.getAttribute('data-empty-label') || 'No Content';

      if (shownCount >= cards.length) {
        button.textContent = emptyLabel;
        button.classList.add('hidden');
      } else {
        button.textContent = label;
        button.classList.remove('hidden');
      }
    };

    const resetDesktop = () => {
      container.style.height = '';
      container.style.position = '';
      lastContainerWidth = 0;

      cards.forEach((el) => {
        el.style.transform = '';
        el.style.width = '';
        el.style.visibility = '';
        el.style.pointerEvents = '';
        el.style.position = '';
        el.style.top = '';
        el.style.left = '';
        delete el.dataset.col;
      });
    };

    const layout = (force = false) => {
      if (!mql.matches) {
        resetDesktop();
        return;
      }

      const items = cards.filter((el) => el.style.display !== 'none');
      if (!items.length) {
        container.style.height = '';
        container.style.position = '';
        return;
      }

      const cw = container.clientWidth;
      if (!cw) return;

      if (force || Math.abs(cw - lastContainerWidth) > 1) {
        items.forEach((el) => delete el.dataset.col);
        lastContainerWidth = cw;
      }

      container.style.position = 'relative';

      const colW = Math.floor((cw - GAP) / COLS);
      const lefts = [0, colW + GAP];
      const heights = new Array(COLS).fill(0);

      for (const el of items) {
        el.style.position = 'absolute';
        el.style.top = '0';
        el.style.left = '0';
        el.style.width = colW + 'px';

        let idx = el.dataset.col != null ? parseInt(el.dataset.col, 10) : -1;
        if (idx !== 0 && idx !== 1) {
          idx = heights[0] <= heights[1] ? 0 : 1;
          el.dataset.col = String(idx);
        }

        const x = lefts[idx];
        const y = heights[idx];

        el.style.transform = `translate3d(${x}px, ${y}px, 0)`;

        const h = el.offsetHeight;
        heights[idx] = y + h + GAP;
      }

      const newH = Math.max(0, Math.max(...heights) - GAP) + 1;
      container.style.height = newH + 'px';
    };

    const scheduleLayout = (force = false) => {
      queuedForce = queuedForce || force;
      if (queued) return;
      queued = true;

      microtask(() => {
        queued = false;
        const f = queuedForce;
        queuedForce = false;
        layout(f);
      });
    };

    const watchImages = (scopeEl) => {
      scopeEl.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        if (img.dataset.rwWatched === '1') return;
        img.dataset.rwWatched = '1';

        img.addEventListener('load', () => scheduleLayout(false), { once: true, passive: true });
        img.addEventListener('error', () => scheduleLayout(false), { once: true, passive: true });
      });
    };

    const initList = () => {
      const batch = currentBatch();
      shownCount = Math.min(batch, cards.length);

      cards.forEach((el, i) => {
        el.style.display = i < shownCount ? '' : 'none';
        el.style.visibility = '';
        el.style.pointerEvents = '';
        delete el.dataset.col;
      });

      updateButton();
      watchImages(container);
      scheduleLayout(true);
    };

    const revealMore = () => {
      const batch = currentBatch();
      const next = Math.min(shownCount + batch, cards.length);
      if (next <= shownCount) {
        updateButton();
        return;
      }

      const newEls = cards.slice(shownCount, next);

      newEls.forEach((el) => {
        el.style.display = '';
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
        delete el.dataset.col;
        watchImages(el);
      });

      shownCount = next;

      updateButton();
      scheduleLayout(true);

      requestAnimationFrame(() => {
        newEls.forEach((el) => {
          el.style.visibility = '';
          el.style.pointerEvents = '';
          el.querySelectorAll('.rw-card').forEach((c) => {
            c.classList.add('rw-fade');
            void c.offsetWidth;
            c.classList.add('is-visible');
          });
        });
      });
    };

    if (rootEl.querySelector('.getyours')) {
      rootEl.addEventListener('click', (e) => {
        const link = e.target.closest('.getyours');
        if (!link) return;
        e.preventDefault();
        const headerHeight = 80;
        const top = rootEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    }

    if (button) {
      button.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          revealMore();
        },
        { passive: false }
      );
    }

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => scheduleLayout(true));
      ro.observe(container);
    } else {
      window.addEventListener('resize', () => scheduleLayout(true), { passive: true });
    }

    const onMqChange = () => scheduleLayout(true);
    if (mql.addEventListener) mql.addEventListener('change', onMqChange);
    else mql.addListener(onMqChange);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleLayout(false));
    }
    window.addEventListener('load', () => scheduleLayout(false), { once: true, passive: true });

    initList();

    const dialog = rootEl.querySelector('[data-rw-modal-dialog]');
    const writeDialog = rootEl.querySelector('[data-rw-write-dialog]');
    const hasCards = !!rootEl.querySelector('[data-rw-modal-card]');

    const EDIT_MODE = String(rootEl.dataset.modalEditMode || 'false') === 'true';

    let locked = false;
    let savedScrollY = 0;

    const REDUCE_MOTION =
      !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const lockPageScroll = () => {
      if (locked) return;
      locked = true;

      savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    };

    const unlockPageScroll = () => {
      if (!locked) return;
      locked = false;

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      window.scrollTo(0, savedScrollY);
    };

    if (dialog && typeof dialog.showModal === 'function' && hasCards) {
      const closeBtn = dialog.querySelector('[data-rw-modal-close]');
      const slotMedia = dialog.querySelector('[data-rw-modal-media]');
      const slotImg = dialog.querySelector('[data-rw-modal-img]');
      const slotStars = dialog.querySelector('[data-rw-modal-stars]');
      const slotText = dialog.querySelector('[data-rw-modal-text]');
      const slotName = dialog.querySelector('[data-rw-modal-name]');
      const slotVerified = dialog.querySelector('[data-rw-modal-verified]');
      const slotLocation = dialog.querySelector('[data-rw-modal-location]');
      const slotDate = dialog.querySelector('[data-rw-modal-date]');

      const close = () => {
        if (EDIT_MODE) return;
        dialog.close();
      };

      const hydrateModalFromCard = (card) => {
        const nameEl = card.querySelector('.rw-text-name');
        const textEl = card.querySelector('.rw-text-main');
        const dateEl = card.querySelector('.rw-card__date');
        const starsEl = card.querySelector('.rw-card__stars, .stars-rw');
        const verifiedEl = card.querySelector('.rw-verified');
        const locationEl = card.querySelector('.rw-location');

        const name = (nameEl?.textContent || '').trim();

        if (slotName) slotName.textContent = name;
        if (slotText) slotText.textContent = (textEl?.textContent || '').trim();
        if (slotDate) slotDate.textContent = (dateEl?.textContent || '').trim();

        if (slotStars) {
          slotStars.innerHTML = '';
          if (starsEl) slotStars.appendChild(starsEl.cloneNode(true));
        }

        if (slotVerified) {
          slotVerified.innerHTML = '';
          if (verifiedEl) slotVerified.appendChild(verifiedEl.cloneNode(true));
        }

        if (slotLocation) {
          slotLocation.innerHTML = '';
          if (locationEl) slotLocation.appendChild(locationEl.cloneNode(true));
        }

        const imgUrl = card.dataset.modalImg || '';
        if (slotMedia && slotImg) {
          if (imgUrl) {
            slotImg.src = imgUrl;
            slotImg.alt = name ? `${name} photo` : 'Review photo';
            slotMedia.hidden = false;
          } else {
            slotMedia.hidden = true;
            slotImg.removeAttribute('src');
            slotImg.alt = '';
          }
        }
      };

      if (EDIT_MODE) {
        const firstCard = rootEl.querySelector('[data-rw-modal-card]');
        if (firstCard) hydrateModalFromCard(firstCard);
      }

      closeBtn?.addEventListener('click', close);

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) close();
      });

      dialog.addEventListener('close', unlockPageScroll);

      dialog.addEventListener('cancel', (e) => {
        if (EDIT_MODE) e.preventDefault();
      });

      rootEl.addEventListener('click', (e) => {
        const card = e.target.closest('[data-rw-modal-card]');
        if (!card || !rootEl.contains(card)) return;

        if (writeDialog?.open) writeDialog.close();

        hydrateModalFromCard(card);
        lockPageScroll();
        dialog.showModal();
      });
    }

    if (writeDialog && typeof writeDialog.showModal === 'function') {
      const backBtn = writeDialog.querySelector('[data-rw-write-back]');
      const writeCloseBtn = writeDialog.querySelector('[data-rw-write-close]');
      const panes = Array.from(writeDialog.querySelectorAll('[data-rw-step-pane]'));
      const starsWrap = writeDialog.querySelector('[data-rw-write-stars]');

      let pendingStep = 0;
      let pendingRating = 0;
      let pendingFallbackTimer = 0;
      let pendingAdvanceTimer = 0;
      const ADVANCE_DELAY_MS = 180;

      const paintWriteStars = (val) => {
        const n = Math.max(0, Math.min(5, parseInt(val || '0', 10) || 0));
        if (!starsWrap) return;

        starsWrap.querySelectorAll('.rw-write-star').forEach((lbl) => {
          const v = parseInt(lbl.dataset.value || '0', 10) || 0;
          lbl.classList.toggle('is-on', v > 0 && v <= n);
        });
      };

      const pressWriteStars = (val) => {
        const n = Math.max(0, Math.min(5, parseInt(val || '0', 10) || 0));
        if (!starsWrap) return;

        const labels = Array.from(starsWrap.querySelectorAll('.rw-write-star'));
        labels.forEach((lbl) => lbl.classList.remove('rw-press'));
        void starsWrap.offsetWidth;

        if (n > 0) {
          labels.forEach((lbl) => {
            const v = parseInt(lbl.dataset.value || '0', 10) || 0;
            if (v > 0 && v <= n) lbl.classList.add('rw-press');
          });
        }
      };

      const getStep = () => parseInt(writeDialog.dataset.rwStep || '1', 10);

      const setStep = (n) => {
        const step = Math.max(1, Math.min(3, n));
        writeDialog.dataset.rwStep = String(step);
        panes.forEach((p) => (p.hidden = p.getAttribute('data-rw-step-pane') !== String(step)));

        requestAnimationFrame(() => {
          const active = panes.find((p) => !p.hidden);
          active?.querySelector('input, textarea, select, button')?.focus?.();
        });
      };

      const clearPending = () => {
        pendingStep = 0;
        pendingRating = 0;

        if (pendingFallbackTimer) {
          clearTimeout(pendingFallbackTimer);
          pendingFallbackTimer = 0;
        }
        if (pendingAdvanceTimer) {
          clearTimeout(pendingAdvanceTimer);
          pendingAdvanceTimer = 0;
        }
      };

      const requestAdvanceAfterStars = (rating, step) => {
        clearPending();

        pendingStep = step;
        pendingRating = rating;

        if (REDUCE_MOTION) {
          setStep(step);
          clearPending();
          return;
        }

        const totalMs = 350 + Math.max(0, (rating - 1) * 60) + 80 + ADVANCE_DELAY_MS;
        pendingFallbackTimer = window.setTimeout(() => {
          if (!starsWrap) return;
          const checked = starsWrap.querySelector('input[type="radio"]:checked');
          const cur = checked ? parseInt(checked.value, 10) || 0 : 0;
          if (pendingStep && cur === pendingRating && pendingRating > 0) {
            setStep(pendingStep);
            clearPending();
          }
        }, totalMs);
      };

      const resetWriteFlow = () => {
        clearPending();
        setStep(1);

        if (starsWrap) {
          starsWrap.querySelectorAll('input[type="radio"]').forEach((i) => (i.checked = false));
          starsWrap.querySelectorAll('.rw-write-star').forEach((lbl) => {
            lbl.classList.remove('rw-press', 'is-on');
          });
        }
        paintWriteStars(0);
      };

      if (starsWrap) {
        starsWrap.addEventListener('change', (e) => {
          const input = e.target;
          if (!(input instanceof HTMLInputElement)) return;
          if (input.type !== 'radio') return;

          const n = Math.max(0, Math.min(5, parseInt(input.value, 10) || 0));
          paintWriteStars(n);
          pressWriteStars(n);

          if (n > 0) requestAdvanceAfterStars(n, 2);
        });

        starsWrap.addEventListener('animationend', (e) => {
          const svg = e.target;
          if (!(svg instanceof SVGElement)) return;

          const lbl = svg.closest('.rw-write-star');
          if (!lbl) return;

          lbl.classList.remove('rw-press');

          if (!pendingStep || !pendingRating) return;

          const v = parseInt(lbl.dataset.value || '0', 10) || 0;
          if (v !== pendingRating) return;

          const checked = starsWrap.querySelector('input[type="radio"]:checked');
          const cur = checked ? parseInt(checked.value, 10) || 0 : 0;
          if (cur !== pendingRating) return;

          if (pendingFallbackTimer) {
            clearTimeout(pendingFallbackTimer);
            pendingFallbackTimer = 0;
          }

          const targetStep = pendingStep;
          const targetRating = pendingRating;

          pendingAdvanceTimer = window.setTimeout(() => {
            if (!starsWrap) return;

            const checked = starsWrap.querySelector('input[type="radio"]:checked');
            const cur = checked ? parseInt(checked.value, 10) || 0 : 0;

            if (cur === targetRating && getStep() === 1) setStep(targetStep);

            clearPending();
          }, ADVANCE_DELAY_MS);
        });
      }

      writeDialog.addEventListener('submit', (e) => {
        const form = e.target instanceof Element ? e.target.closest('.rw-write-form') : null;
        if (!form) return;
        e.preventDefault();
        setStep(3);
      });

      writeDialog.addEventListener('click', (e) => {
        const submitBtn = e.target.closest('.rw-write-submit');
        if (!submitBtn) return;

        const form = submitBtn.closest('form');
        if (form) {
          e.preventDefault();
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });

      const closeWrite = () => {
        if (EDIT_MODE) return;
        clearPending();
        writeDialog.close();
      };

      writeCloseBtn?.addEventListener('click', closeWrite);

      backBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        clearPending();
        setStep(1);
      });

      writeDialog.addEventListener('click', (e) => {
        if (e.target === writeDialog) closeWrite();
      });

      writeDialog.addEventListener('close', () => {
        clearPending();
        unlockPageScroll();
      });

      writeDialog.addEventListener('cancel', (e) => {
        if (EDIT_MODE) e.preventDefault();
      });

      rootEl.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-rw-open-write]');
        if (!opener) return;

        e.preventDefault();
        if (EDIT_MODE) return;

        if (dialog?.open) dialog.close();

        lockPageScroll();
        resetWriteFlow();
        writeDialog.showModal();

        requestAnimationFrame(() => {
          writeDialog
            .querySelector(
              '[data-rw-step-pane="1"] input, [data-rw-step-pane="1"] button, [data-rw-step-pane="1"] [tabindex]'
            )
            ?.focus?.();
        });
      });
    }
  });
})();